import { useQuery } from "@tanstack/react-query";
import { apiRelLitragemMensal, type TApiLitragemMensal } from "pages/relatorios/api/apiRelLitragemMensal";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import type { TExportToCSV } from "std/csv";
import { FilterBar } from "./FilterBar";
import { columns, TableRelLitragemMensal } from "./TableRelLitragemMensal";

export function RelatorioLitragemMensal() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelLitragemMensal", params],
		queryFn: () => apiRelLitragemMensal({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	const csvData: TExportToCSV<TApiLitragemMensal> = useMemo(() => {
		return {
			type: "multitable",
			fileName: "relatorio-litragem-mensal",
			options: {
				// biome-ignore lint/suspicious/noExplicitAny: dynamic
				columns: columns as any,
				data: registros,
				parentColumn: "rot_identificacao",
				childKey: "coletaItens",
			},
		};
	}, [registros]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados de Litragem Mensal";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Litragem", "Mensal"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			csvData={csvData}
			registros={registros}
			table={<TableRelLitragemMensal data={data?.registros} title={title} />}
		/>
	);
}
